import React from 'react';

import {Col, Row} from 'antd';
import './CustomerAccountDetailsPanel.css';
import FieldValueVerticalCell from 'components/general/FieldValueVerticalCell';

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";


class CustomerAccountDetailsPanel extends React.Component {

    render() {
        const intl = this.props.useIntl;
        return (
            <div className="originator-details">
                <Row style={{marginBottom: "20px"}}>
                    <Col md={6} sm={12}>
                        <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.nameofsender"})} value={this.props.currentCustomer.name} />
                    </Col>

                    <Col md={8} sm={12}>
                        <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.sendertype"})} value={'SELF'}/>
                    </Col>

                    <Col md={5} sm={12}>
                        <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.sourceoffunds"})} value={this.props.currentCustomer.corporateAccountDetails ? this.props.currentCustomer.corporateAccountDetails.sourceOfFunds :"-"} />
                    </Col>
                    <Col md={5} sm={12}>
                        <FieldValueVerticalCell
                            title={intl.formatMessage({id: "app.panel.originatordetailspanel.referencenumber"})}
                            value={this.props.currentCustomer.referenceNumber}/>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withUseIntl(CustomerAccountDetailsPanel);